import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const INTEGRATIONS_TAGS = {
  SETTINGS: 'settings',
};

export const integrationsApiSlice = createApi({
  reducerPath: 'integrationsApiSlice',
  tagTypes: Object.values(INTEGRATIONS_TAGS),
  baseQuery,
  endpoints: (builder) => ({
    getIntegrationsSettings: builder.query({
      query: ({ apiManager, ...rest }) => apiManager.getIntegrationsSettings(rest),
      // The backend serializes "no integrations" as an empty array `[]`. Coerce
      // to an object so the keyed lookups (`key in data`) and the optimistic add
      // in the view (`draft[key] = ...` via Immer) operate on an object — Immer
      // throws when a string key is set on an array draft.
      transformResponse: (response) => (Array.isArray(response) ? {} : (response ?? {})),
      providesTags: [INTEGRATIONS_TAGS.SETTINGS],
    }),
  }),
  serializeQueryArgs,
});

export const { useGetIntegrationsSettingsQuery } = integrationsApiSlice;
